/*
  Possible states of app:
    'init',
    'introduction',
    'intro-anim',
    'instruction',
    'playing',
    'playing-show-card',
    'show-testimonials',
    'finished'
*/

const state = {
  current: 'init',
  previous: null,
  hasBeenRestarted: false,
}

const mutations = {
  UPDATE_APP_STATE (state, payload) {
    state.previous = state.current
    state.current = payload.state

    if(payload.hasBeenRestarted) {
      state.hasBeenRestarted = true;
    }

    console.log('%c APP STATE UPDATED TO:  ', 'background: #4D3A4B; color: #bada55', payload.state)
    // console.log('hasBeenRestarted:  ', state.hasBeenRestarted);
  }
}

const actions = {
  updateAppState (context, payload) {
    context.commit('UPDATE_APP_STATE', payload)
  },
  goToLastAppState (context, payload) {
    // console.log('context:  ', context);
    let previousState = context.state.previous;
    payload = {
      state: previousState
    }

    context.commit('UPDATE_APP_STATE', payload);
  },
  setAppStateForPlayAgain(context, payload) {
    context.commit('UPDATE_APP_STATE', {
      state: 'intro-anim',
      hasBeenRestarted: true,
    });
  },
}

const getters = {
  getAppState: state => state.current,
  getHasBeenRestartedState: state => state.hasBeenRestarted,
  getPreviousAppState: state => state.previous,
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/App.js